<template>
    <div class="page-title-area item-bg1">
        <div class="container">
            <div class="page-title-content">
                <h2>Transparent Pricing</h2>
                <p>Borderless account pricing</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PageTitle'
    }
</script>